const Loader = {
    functional: true,
    render: (h, {props}) => {
        return <svg class="bx-loader-spinner fa-pulse" viewBox="0 0 512 512"
                    fill="#324A6D" style={{
            'margin': 'auto',
            'display': 'block',
            'shape-rendering': 'auto',
        }} {...props}>
            <path
                d="M108.92 355.08a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM256 416a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm208-208a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm-60.92 147.08a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0-198.16a48 48 0 1 0-48-48 48 48 0 0 0 48 48z"/>
            <path opacity=".4"
                  d="M108.92 60.92a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM48 208a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM256 0a48 48 0 1 0 48 48 48 48 0 0 0-48-48z"/>
        </svg>
    },
}
export default Loader;
